class TextReadMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.text-read-more-button');
    this.content = this.querySelector('.text-read-more-content');
    this.isExpanded = false;
    
    if (this.button) {
      this.button.addEventListener('click', this.toggle.bind(this));
      // Initial check with a slight delay to ensure DOM is ready
      setTimeout(() => {
        this.checkOverflow();
      }, 0);
      window.addEventListener('resize', this.checkOverflow.bind(this));
    }
  }

  checkOverflow() {
    const visibility = this.dataset.visibility || 'mobile';
    const isMobile = window.innerWidth <= 749;
    
    // Check if read more should be enabled based on visibility setting
    let shouldEnable = false;
    if (visibility === 'both') {
      shouldEnable = true;
    } else if (visibility === 'mobile' && isMobile) {
      shouldEnable = true;
    } else if (visibility === 'desktop' && !isMobile) {
      shouldEnable = true;
    } else if (visibility === 'none') {
      shouldEnable = false;
    }
    
    if (!shouldEnable) {
      this.button?.classList.add('hidden');
      this.content?.classList.remove('text-read-more-content--clamped');
      return;
    }

    if (this.content) {
      const lineClamp = parseInt(this.dataset.lineClamp) || 3;
      this.content.style.setProperty('--line-clamp', lineClamp);
      
      // Always add the clamped class when enabled - CSS will handle visibility
      this.content.classList.add('text-read-more-content--clamped');
      
      // Use requestAnimationFrame to ensure styles are applied before checking
      requestAnimationFrame(() => {
        // Check if content is actually clamped/overflowing
        const isOverflowing = this.content.scrollHeight > this.content.clientHeight;
        
        if (isOverflowing) {
          this.button?.classList.remove('hidden');
        } else {
          this.button?.classList.add('hidden');
        }
      });
    }
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
    
    if (this.isExpanded) {
      this.content?.classList.remove('text-read-more-content--clamped');
      this.button.querySelector('.text-read-more-label').textContent = 'Read Less';
      this.button.classList.add('text-read-more-button--expanded');
    } else {
      this.content?.classList.add('text-read-more-content--clamped');
      this.button.querySelector('.text-read-more-label').textContent = 'Read More';
      this.button.classList.remove('text-read-more-button--expanded');
    }
  }
}

if (!customElements.get('text-read-more')) {
  customElements.define('text-read-more', TextReadMore);
}

